
import { useState } from 'react';

interface Testimonial {
  id: number;
  name: string;
  location: string;
  rating: number;
  date: string;
  service: string;
  review: string;
  projectImage: string;
  avatar: string;
}

export default function TestimonialsGrid() {
  const [selectedFilter, setSelectedFilter] = useState('all');

  const testimonials: Testimonial[] = [
    {
      id: 1,
      name: 'Sarah Mitchell',
      location: 'Rickmansworth',
      rating: 5,
      date: 'January 2025',
      service: 'Interior Painting',
      review: 'Absolutely outstanding service from start to finish! The team at Brushour transformed our living room and hallway beyond our expectations. They were professional, punctual, and incredibly meticulous with their work. The attention to detail was remarkable - they protected all our furniture and floors, and the cleanup was impeccable. The quality of the paint finish is flawless, with perfectly smooth walls and crisp, clean lines. We have already recommended them to three of our neighbors!',
      projectImage: 'https://static.readdy.ai/image/3d769dc1e01059223eb26668720a1761/1a660fe85c03d6d72d6e3289bf07f65e.jpeg',
      avatar: 'https://public.readdy.ai/ai/img_res/6b334a83f96dd0915e9201d9c163a1ba.jpg',
    },
    {
      id: 2,
      name: 'James Thompson',
      location: 'Chorleywood',
      rating: 5,
      date: 'December 2024',
      service: 'Exterior Painting',
      review: 'We hired Brushour to paint the exterior of our home, and they did an exceptional job. The preparation work was thorough - they spent days properly preparing the surfaces, filling cracks, and ensuring everything was perfect before painting. The team worked efficiently even in challenging weather conditions. The transformation is stunning! Our home looks brand new, and neighbors keep stopping to compliment the work. The paint quality is clearly premium, and we are confident it will last for years. Worth every penny!',
      projectImage: 'https://static.readdy.ai/image/3d769dc1e01059223eb26668720a1761/b887b446390a9aaff87f9cd2596140e8.jpeg',
      avatar: 'https://readdy.ai/api/search-image?query=casual%20natural%20photo%20of%20man%20outdoors%20relaxed%20everyday%20clothing%20friendly%20smile%20candid%20snapshot%20style%20authentic%20real%20person%20informal&width=200&height=200&seq=avatar-casual-2&orientation=squarish',
    },
    {
      id: 3,
      name: 'Emma Richardson',
      location: 'Northwood',
      rating: 5,
      date: 'November 2024',
      service: 'Wallpaper Installation',
      review: 'I was nervous about having wallpaper installed in our dining room, but Brushour made the entire process stress-free. Their expertise in wallpaper hanging is evident - the pattern matching is perfect, and there are no bubbles or imperfections anywhere. They helped us choose the right wallpaper for our space and provided excellent advice on maintenance. The team was respectful of our home, always wearing shoe covers and keeping the work area clean. The final result is absolutely gorgeous and has become the centerpiece of our home!',
      projectImage: 'https://static.readdy.ai/image/3d769dc1e01059223eb26668720a1761/1481ce4bb874d1588eb11de36f2404a3.jpeg',
      avatar: 'https://readdy.ai/api/search-image?query=casual%20natural%20photo%20of%20woman%20indoors%20relaxed%20everyday%20style%20warm%20smile%20candid%20snapshot%20authentic%20real%20person%20informal%20setting&width=200&height=200&seq=avatar-casual-3&orientation=squarish',
    },
    {
      id: 4,
      name: 'Michael Chen',
      location: 'Pinner',
      rating: 5,
      date: 'October 2024',
      service: 'Kitchen Cabinet Painting',
      review: 'Brushour gave our dated kitchen a complete makeover by painting our cabinets, and we could not be happier! Instead of spending thousands on new cabinets, they transformed our existing ones for a fraction of the cost. The preparation was extensive - they removed all doors, cleaned, sanded, and primed everything properly. The spray finish is factory-quality smooth with no brush marks. They used high-quality paint that is durable and easy to clean. Our kitchen looks modern and fresh. This was the best home improvement decision we have made!',
      projectImage: 'https://static.readdy.ai/image/3d769dc1e01059223eb26668720a1761/326413aec6fc2da40c0cf7b0b71c45a2.jpeg',
      avatar: 'https://readdy.ai/api/search-image?query=casual%20natural%20photo%20of%20Asian%20man%20at%20home%20relaxed%20everyday%20clothing%20friendly%20expression%20candid%20snapshot%20style%20authentic%20real%20person%20informal&width=200&height=200&seq=avatar-casual-4&orientation=squarish',
    },
    {
      id: 5,
      name: 'Lucy Anderson',
      location: 'Bushey',
      rating: 5,
      date: 'September 2024',
      service: 'Bedroom Painting',
      review: 'We had three bedrooms painted by Brushour, and the experience was fantastic from beginning to end. The quote was detailed and transparent with no hidden costs. The painters arrived exactly on time each day and worked diligently. They were happy to accommodate our color choices and even provided samples on the walls to help us decide. The finish is beautiful - smooth, even coverage with no drips or streaks. They also painted the ceilings, which made a huge difference. Our bedrooms feel like luxury hotel rooms now. Highly recommend!',
      projectImage: 'https://static.readdy.ai/image/3d769dc1e01059223eb26668720a1761/46531b69930dd1ec1d2d05e6990917ba.jpeg',
      avatar: 'https://readdy.ai/api/search-image?query=casual%20natural%20photo%20of%20young%20woman%20smiling%20relaxed%20everyday%20clothing%20candid%20snapshot%20style%20authentic%20real%20person%20informal%20home%20setting&width=200&height=200&seq=avatar-casual-5&orientation=squarish',
    },
    {
      id: 6,
      name: 'Watford Town Centre BID',
      location: 'Watford',
      rating: 5,
      date: 'March 2024',
      service: 'Commercial Painting',
      review: 'Watford Town Centre BID highly recommend Brushour for commercial painting requirements. They recently painted our office to an exceptionally high standard. They were professional, respectful and completed the works on time whilst keeping us fully updated on their progress - Thank you!',
      projectImage: 'https://static.readdy.ai/image/3d769dc1e01059223eb26668720a1761/143118a7421ea7e0ed38899b421463cc.jpeg',
      avatar: 'https://readdy.ai/api/search-image?query=casual%20photo%20of%20office%20building%20exterior%20simple%20everyday%20view%20natural%20lighting%20authentic%20real%20business%20location%20informal%20snapshot&width=200&height=200&seq=avatar-casual-bid&orientation=squarish',
    },
    {
      id: 7,
      name: 'Sophie Turner',
      location: 'Gerrards Cross',
      rating: 5,
      date: 'July 2024',
      service: 'Decorative Finishes',
      review: 'We wanted something special for our entrance hall, and Brushour created a stunning feature wall with decorative painting techniques. Their artistic skills are impressive! They showed us samples and worked with us to create the perfect design. The execution was flawless - the colors blend beautifully, and the texture adds incredible depth to the space. Every guest who visits comments on how beautiful it looks. The team was patient with our requests and made sure we were completely satisfied. This is true craftsmanship, and we are thrilled with the result!',
      projectImage: 'https://static.readdy.ai/image/3d769dc1e01059223eb26668720a1761/0c4df16eee67a2e4599c9fdc47b83442.jpeg',
      avatar: 'https://readdy.ai/api/search-image?query=casual%20natural%20photo%20of%20woman%20at%20home%20relaxed%20everyday%20style%20genuine%20smile%20candid%20snapshot%20authentic%20real%20person%20informal%20setting&width=200&height=200&seq=avatar-casual-7&orientation=squarish',
    },
    {
      id: 8,
      name: 'Robert Davies',
      location: 'Rickmansworth',
      rating: 5,
      date: 'June 2024',
      service: 'Full House Painting',
      review: 'Brushour painted our entire house - every room, hallway, and staircase. This was a major project, and they handled it brilliantly. The project manager kept us informed throughout, and the timeline was accurate. The quality is consistent throughout the house, which shows their attention to detail and professionalism. They worked around our schedule and were flexible when we needed to make changes. The painters were friendly, respectful, and clearly skilled at their craft. Our house feels completely refreshed and modern. This was a significant investment, but the quality of work justifies every pound spent!',
      projectImage: 'https://static.readdy.ai/image/3d769dc1e01059223eb26668720a1761/ca8f41d7404a7d7811024a3735273610.jpeg',
      avatar: 'https://readdy.ai/api/search-image?query=casual%20natural%20photo%20of%20mature%20man%20outdoors%20relaxed%20everyday%20clothing%20friendly%20smile%20candid%20snapshot%20style%20authentic%20real%20person%20informal&width=200&height=200&seq=avatar-casual-8&orientation=squarish',
    },
    {
      id: 9,
      name: 'Hannah Brooks',
      location: 'Chorleywood',
      rating: 5,
      date: 'May 2024',
      service: 'Bathroom Painting',
      review: 'Our bathroom needed updating, and Brushour did an amazing job painting it. They used specialized moisture-resistant paint perfect for bathrooms and ensured proper ventilation during the process. The preparation included treating some minor mold issues and repairing small cracks in the plaster. The finish is smooth and professional, and the color we chose has completely transformed the space. They were careful around all the fixtures and fittings, and everything was protected properly. The bathroom now feels like a spa! Great value for money and excellent customer service throughout.',
      projectImage: 'https://static.readdy.ai/image/3d769dc1e01059223eb26668720a1761/98c86e916c30f838db3012a1700bae7f.jpeg',
      avatar: 'https://readdy.ai/api/search-image?query=casual%20natural%20photo%20of%20young%20woman%20smiling%20relaxed%20everyday%20clothing%20candid%20snapshot%20style%20authentic%20real%20person%20informal%20home%20setting&width=200&height=200&seq=avatar-casual-9&orientation=squarish',
    },
  ];

  const services = ['all', 'Interior Painting', 'Exterior Painting', 'Wallpaper Installation', 'Kitchen Cabinet Painting', 'Commercial Painting'];

  const filteredTestimonials = selectedFilter === 'all' 
    ? testimonials 
    : testimonials.filter(t => t.service === selectedFilter);

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-amber-600 text-sm font-medium tracking-wider uppercase mb-3">Reviews</p>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-4">
            What Our Customers Say
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Real reviews from real customers. Every testimonial represents a successful project and a satisfied homeowner.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {services.map((service) => (
            <button
              key={service}
              onClick={() => setSelectedFilter(service)}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                selectedFilter === service
                  ? 'bg-amber-600 text-white'
                  : 'bg-beige-100 text-gray-700 hover:bg-beige-200'
              }`}
            >
              {service === 'all' ? 'All Reviews' : service}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredTestimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-xl border border-beige-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
            >
              <div className="relative w-full h-64 overflow-hidden">
                <img
                  src={testimonial.projectImage}
                  alt={`${testimonial.service} project`}
                  className="w-full h-full object-cover object-[center_40%]"
                />
                <div className="absolute top-4 right-4 px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full">
                  <span className="text-xs font-medium text-gray-800">{testimonial.service}</span>
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center gap-3 mb-4">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full object-cover ring-2 ring-beige-200"
                  />
                  <div>
                    <h3 className="text-base font-bold text-gray-800">{testimonial.name}</h3>
                    <p className="text-xs text-gray-600">{testimonial.location}</p>
                  </div>
                </div>

                <div className="flex items-center gap-1 mb-3">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="fas fa-star text-amber-500 text-sm"></i>
                  ))}
                  <span className="text-xs text-gray-600 ml-2">{testimonial.date}</span>
                </div>

                <p className="text-sm text-gray-600 leading-relaxed">
                  {testimonial.review}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
